jQuery.fn.extend({
    showModal: function () {
        return this.each(function () {
            if (this.tagName === "DIALOG") {
                this.showModal();
                jQuery(this).trigger("opened");
            }
        });
    },
    close: function () {
        return this.each(function () {
            if (this.tagName === "DIALOG") {
                this.close();
                jQuery(this).trigger("closed");
            }
        });
    }
});
